const getUrlFromImageSource = (node) => node.getAttribute('src');

export default getUrlFromImageSource;
